import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import UserDashboard from './dashboard/UserDashboard';

const Home = () => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      {isAuthenticated ? (
        <Container>
          {/* Hero Section for Logged In Users */}
          <Row className="py-5">
            <Col md={6} className="d-flex flex-column justify-content-center mb-md-0 mb-4">
              <h1 className="display-4 fw-bold text-primary">Welcome Back!</h1>
              <p className="lead">
                Explore your matches and connections on Paperdate.
              </p>
              <div className="d-flex gap-3 mt-3 hero-buttons">
                <Button as={Link} to="/search/results" variant="primary" size="lg" className="btn-match">
                  Find Matches
                </Button>
                <Button as={Link} to="/profile" className="btn-profile" size="lg">
                  My Profile
                </Button>
              </div>
            </Col>
            <Col md={6}>
              <img
                src="/images/couples/romantic-couple-4.jpg"
                alt="Romantic Couple"
                className="img-fluid rounded shadow hero-image"
                style={{ objectFit: 'cover', height: '400px', width: '100%' }}
              />
            </Col>
          </Row>

          {/* User Dashboard */}
          <UserDashboard />
        </Container>
      ) : (
        <>
          {/* Hero Section for Non-Logged In Users */}
          <div className="hero-section py-5" style={{ minHeight: '500px' }}>
            <Container>
              <Row className="align-items-center py-5">
                <Col lg={6} className="text-center text-lg-start mb-4 mb-lg-0">
                  <h1 className="display-3 fw-bold mb-4 text-dark">Relationships Made Simple with PaperDate</h1>
                  <p className="lead mb-4 text-dark">
                    Instantly propose PaperDate First Dates with thousands of Verified Members
                  </p>
                  <Button
                    as={Link}
                    to="/register"
                    size="lg"
                    className="btn-love text-uppercase fw-bold px-5 py-3"
                  >
                    GET STARTED
                  </Button>
                </Col>
                <Col lg={6}>
                  <img
                    src="/images/couples/romantic-couple-4.jpg"
                    alt="Happy Couple"
                    className="img-fluid rounded shadow"
                    style={{ objectFit: 'cover', maxHeight: '400px', width: '100%' }}
                  />
                </Col>
              </Row>
            </Container>
          </div>

          {/* Three Step Process */}
          <Container className="py-5">
            <Row className="text-center g-4">
              <Col md={4}>
                <div className="mb-3">
                  <i className="bi bi-people-fill text-primary" style={{ fontSize: '3rem' }}></i>
                </div>
                <h5 className="fw-bold">Browse Thousands of Verified Members</h5>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <i className="bi bi-calendar-heart text-primary" style={{ fontSize: '3rem' }}></i>
                </div>
                <h5 className="fw-bold">Instantly Propose First Dates</h5>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <i className="bi bi-chat-heart text-primary" style={{ fontSize: '3rem' }}></i>
                </div>
                <h5 className="fw-bold">Meet in Person Discuss Future Relationship</h5>
              </Col>
            </Row>
          </Container>

          {/* How PaperDate Works Video Section */}
          <div className="bg-light-accent py-5">
            <Container>
              <Row className="text-center mb-4">
                <Col>
                  <h2 className="fw-bold display-5">How PaperDate works</h2>
                </Col>
              </Row>
            </Container>
          </div>

          {/* How PaperDate Relationships Work */}
          <Container className="py-5">
            <Row className="align-items-center">
              <Col lg={6} className="mb-4 mb-lg-0">
                <img
                  src="/images/couples/romantic-couple-4.jpg"
                  alt="Couple"
                  className="img-fluid rounded shadow"
                />
              </Col>
              <Col lg={6}>
                <h2 className="fw-bold mb-4">How PaperDate Relationships Work</h2>
                <p className="mb-4">
                  At its core, PaperDate Dating is about finding a partner. The PaperDate Relationship Contract
                  is a document that gets written up and signed by two people in an intimate relationship. This
                  contract is a catalyst for a very honest conversation. It isn't legally binding. It isn't a
                  marital contract. It's a PaperDate Relationship Contract.
                </p>
                <Button as={Link} to="/register" variant="primary" className="btn-match">
                  Join PaperDate today
                </Button>
              </Col>
            </Row>
          </Container>

          {/* The PaperDate First Date */}
          <div className="bg-light-accent py-5">
            <Container>
              <Row className="align-items-center">
                <Col lg={6} className="order-lg-2 mb-4 mb-lg-0">
                  <img
                    src="/images/couples/romantic-couple-4.jpg"
                    alt="First Date"
                    className="img-fluid rounded shadow"
                  />
                </Col>
                <Col lg={6} className="order-lg-1">
                  <h2 className="fw-bold mb-4">The spark of PaperDate: The PaperDate First Date</h2>
                  <p className="mb-4">
                    Both the Generous Man and the Attractive Girl will agree on a time, location and activity
                    for their PaperDate First Date. PaperDate makes setting up this initial First Date simple
                    with our patent-pending PaperDate First Date system, you can propose the details of your
                    First Date without wasting each others time.
                  </p>
                  <Button as={Link} to="/register" variant="primary" className="btn-match">
                    Plan your First Date
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>

          {/* Advantages of Attractive Girls */}
          <Container className="py-5">
            <Row className="text-center mb-4">
              <Col>
                <h2 className="fw-bold display-5">Advantages of Attractive Girls</h2>
              </Col>
            </Row>
            <Row className="g-4 mb-4">
              <Col md={4} className="text-center">
                <div className="mb-3">
                  <i className="bi bi-gem text-primary" style={{ fontSize: '3rem' }}></i>
                </div>
                <h5 className="fw-bold">Classy Dates, Pampering, and Perks</h5>
              </Col>
              <Col md={4} className="text-center">
                <div className="mb-3">
                  <i className="bi bi-graph-up-arrow text-primary" style={{ fontSize: '3rem' }}></i>
                </div>
                <h5 className="fw-bold">Mentorship to help Network and Grow</h5>
              </Col>
              <Col md={4} className="text-center">
                <div className="mb-3">
                  <i className="bi bi-heart-fill text-primary" style={{ fontSize: '3rem' }}></i>
                </div>
                <h5 className="fw-bold">Mature Relationships, no Games</h5>
              </Col>
            </Row>
            <Row className="text-center">
              <Col>
                <Button as={Link} to="/register" variant="primary" size="lg" className="btn-love">
                  Join as Attractive Girl
                </Button>
              </Col>
            </Row>
          </Container>

          {/* Advantages of Generous Men */}
          <div className="bg-light-accent py-5">
            <Container>
              <Row className="text-center mb-4">
                <Col>
                  <h2 className="fw-bold display-5">Advantages of Generous Men</h2>
                </Col>
              </Row>
              <Row className="g-4 mb-4">
                <Col md={4} className="text-center">
                  <div className="mb-3">
                    <i className="bi bi-star-fill text-primary" style={{ fontSize: '3rem' }}></i>
                  </div>
                  <h5 className="fw-bold">Meet Young, Beautiful, Confident Women</h5>
                </Col>
                <Col md={4} className="text-center">
                  <div className="mb-3">
                    <i className="bi bi-chat-square-text text-primary" style={{ fontSize: '3rem' }}></i>
                  </div>
                  <h5 className="fw-bold">Honest and Open Relationships</h5>
                </Col>
                <Col md={4} className="text-center">
                  <div className="mb-3">
                    <i className="bi bi-trophy-fill text-primary" style={{ fontSize: '3rem' }}></i>
                  </div>
                  <h5 className="fw-bold">Live the Life you've Dreamed!</h5>
                </Col>
              </Row>
              <Row className="text-center">
                <Col>
                  <Button as={Link} to="/register" variant="primary" size="lg" className="btn-love">
                    Join as Generous Man
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>

          {/* Final CTA Section */}
          <div className="bg-secondary py-5">
            <Container>
              <Row className="text-center">
                <Col>
                  <h2 className="fw-bold display-5 mb-4 text-dark">Propose Your Next PaperDate First Date in Seconds</h2>
                  <Button
                    as={Link}
                    to="/register"
                    size="lg"
                    className="btn-love text-uppercase fw-bold px-5 py-3"
                  >
                    Propose a First Date Now
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>
        </>
      )}
    </>
  );
};

export default Home;
